<template>
  <div class="main-feed mt-5">
    <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
    <div>
      <v-row class="ma-0">
        <h2>Edit Members Only Content</h2>
      </v-row>
      <v-btn :disabled="disableSave" v-on:click="save" :loading="isSaving">Save</v-btn>
      <div ref="editor"></div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import Quill from "quill";
import { isEmpty } from "lodash";
import "quill/dist/quill.snow.css";

import memberService from "@/services/admin/memberService";
import userService from "@/services/portal/userService";

const toolbar = [
  ["bold", "italic", "underline", "strike"],
  ["blockquote", "code-block"],
  [{ header: 1 }, { header: 2 }],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }],
  [{ indent: "-1" }, { indent: "+1" }],
  [{ direction: "rtl" }],
  [{ size: ["small", false, "large", "huge"] }],
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ color: [] }, { background: [] }],
  [{ font: [] }],
  [{ align: [] }],
  ["clean"],
  ["link", "image", "video"],
];

export default Vue.extend({
  name: "MembersOnlyEdit",
  data: function () {
    return {
      errors: [] as string[],
      content: null as string | null,
      initContent: null as string | null,
      quill: null as Quill | null,
      editorChangeHandler: null as (() => void) | null,
      isSaving: false,
      isLoading: false,
    };
  },
  methods: {
    getEditorHtml: function (): string {
      if (!this.quill) return "";

      const operations = this.quill.getContents().ops;
      const isEmptyEditor = operations.length === 1 && operations[0].insert === "\n";
      return isEmptyEditor ? "" : this.quill.getSemanticHTML();
    },
    loadEditorContent: function (html: string | null) {
      const content = html || "";
      if (!this.quill) {
        this.content = content;
        this.initContent = content;
        return;
      }

      if (this.editorChangeHandler) {
        this.quill.off("text-change", this.editorChangeHandler);
      }
      this.quill.clipboard.dangerouslyPasteHTML(content, "api");
      this.quill.history.clear();
      this.content = this.getEditorHtml();
      this.initContent = this.content;
      if (this.editorChangeHandler) {
        this.quill.on("text-change", this.editorChangeHandler);
      }
    },
    save: function () {
      if (!this.content) return;
      this.isSaving = true;
      memberService
        .updateMembersOnlyInfo(this.content)
        .then((res) => {
          this.loadEditorContent(res.data);
          this.isSaving = false;
          })
          .catch(() => {
            this.isSaving = false;
          });
    },
  },
  created: function () {
    this.isLoading = true;
    userService
      .getMembersOnlyInfo()
      .then((res) => {
        this.loadEditorContent(res.data);
        this.isLoading = false;
      })
      .catch(() => {
        this.isLoading = false;
      });
  },
  mounted: function () {
    const container = this.$refs.editor as HTMLElement;
    container.innerHTML = this.content || "";
    this.quill = new Quill(container, {
      modules: { toolbar },
      placeholder: "Insert text here ...",
      theme: "snow",
    });
    this.editorChangeHandler = () => {
      this.content = this.getEditorHtml();
    };
    this.quill.on("text-change", this.editorChangeHandler);

    if (this.content !== null) {
      this.content = this.getEditorHtml();
      this.initContent = this.content;
      this.quill.history.clear();
    }
  },
  beforeDestroy: function () {
    if (this.quill && this.editorChangeHandler) {
      this.quill.off("text-change", this.editorChangeHandler);
      this.quill.disable();
    }
    this.editorChangeHandler = null;
    this.quill = null;
  },
  computed: {
    disableSave(): boolean {
      return this.initContent === this.content || isEmpty(this.content)
    }
  }
});
</script>
